module.exports = __webpack_public_path__ + "static/media/icone_QRCODE.c80301a1.svg";